import React from "react";

import {
  browserVersionLessThan,
  isIE,
  isSafari
} from "features/common/utils/functions/browser";
import { getAppName } from "features/plurall";

import DeviceWarningModal from "./DeviceWarningModal";
import InternetExplorerNotSupportedModal from "./InternetExplorerNotSupportedModal";

export default function BrowserVersionNotSupportedModal() {
  if (isIE()) {
    return <InternetExplorerNotSupportedModal />;
  }

  return (
    <DeviceWarningModal
      topMessage={`Sorry you can’t use ${getAppName()} on this version of Safari. Please use a newer version of Chrome, Firefox, Safari or Edge.`}
    />
  );
}

export const browserVersionIsNotSupported = () =>
  safariVersionNotSupported || isIE();

const safariVersionNotSupported = isSafari() && browserVersionLessThan("11");
